import { forwardRef } from 'react';
import { Typography, type TypographyProps, useTheme } from '@material-ui/core';
import cx from 'classnames';

import * as env from 'src/lib/env';

import { TYPOGRAPHY_VARIANT, type TypographyVariant } from './const';
// @ts-expect-error "useStyles" does not have types
import { useStyles } from './useStyles';

interface Props extends Omit<TypographyProps, 'variant'> {
  variant?: TypographyVariant;
}

export const CustomTypography = forwardRef<HTMLParagraphElement, Props>(
  ({ className, variant = TYPOGRAPHY_VARIANT.regular14, ...restProps }, ref) => {
    const styles = useStyles({ variant });
    const theme = useTheme();

    if (env.getAppEnv() !== 'production') {
      if (!variant) {
        // eslint-disable-next-line no-console
        console.error(`CustomTypography: required "variant" property is not defined`);
      }

      if ((theme.typography as unknown as Record<string, unknown>)[variant] === undefined) {
        // eslint-disable-next-line no-console
        console.error(
          `CustomTypography: unknown variant "${variant}", cannot find any options for it in "theme.typography"`
        );
      }
    }

    return (
      <Typography
        className={cx(styles.root, className)}
        ref={ref}
        {...restProps}
      />
    );
  }
);

CustomTypography.displayName = 'CustomTypography';
